export default "__VITE_ASSET__DCiZ0eXF__"